// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__UMfiz","savePackageButton":"ClientWallet_savePackageButton__19yS9"};